import i18next from 'i18next';
import { message } from 'antd';

import { navigate } from '~/services/navigate';
import { signOutRequest } from '~/store/modules/auth/actions';

const online = navigator.onLine;

const handleErrorStatus = (status, data) => {
  if (data?.retorno) {
    message.error(data?.retorno);
    return;
  }

  const statusMessages = {
    422: 'messages:invalidData',
    403: 'messages:unauthorized',
    401: 'messages:authError',
    500: 'messages:randomError',
    406: 'messages:notAcceptable',
  };

  switch (status) {
    case 401:
      dispatchEvent(signOutRequest());
      break;
    case 404:
      navigate('/404');
      break;
    default:
      message.error(i18next.t(statusMessages[status || 500]));
      break;
  }
};

const errorHandler = (exception) => {
  const { response } = exception;

  if (!online) {
    message.error(i18next.t('messages:offline'));
    return;
  }

  if (response) {
    const { status, data } = response;
    const parsedData = typeof data === 'string' ? JSON.parse(data) : data;

    if (status === 422 && parsedData?.message) {
      message.error(parsedData?.retorno);

      return parsedData?.message;
    }

    handleErrorStatus(status, parsedData);
  } else if (exception?.message === 'Network Error') {
    message.error(i18next.t('messages:backendOff'));
  } else {
    message.error(i18next.t('messages:randomError'));
  }
};

export default errorHandler;
